import script from "./GameRule.vue?vue&type=script&setup=true&lang=js"
export * from "./GameRule.vue?vue&type=script&setup=true&lang=js"

import "./GameRule.vue?vue&type=style&index=0&id=a8b1ece0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8b1ece0"]])

export default __exports__